import { render, staticRenderFns } from "./ClassTeacherName.vue?vue&type=template&id=83bf77ae&"
import script from "./ClassTeacherName.vue?vue&type=script&lang=js&"
export * from "./ClassTeacherName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports